import { orchestrator } from 'satcheljs';
import { getSubscriberType } from '../services/getSubscriberType';
import setSubscriberType from '../mutators/setSubscriberType';
import { getSubscriberType as getSubscriberTypeAction } from '../actions/getSubscriberType';

export default orchestrator(getSubscriberTypeAction, async function getSubscriberTypeAction() {
    let response = await getSubscriberType();
    setSubscriberType(response);
});
